import * as React from 'react';
import keyCodes from '../../../../constants/KeyCodes';
import {getLocalizedText, texts} from '../../../../constants/TextConst';

class SearchPanel extends React.Component<any, any> {
    wrapperRef: HTMLElement;
    input: HTMLInputElement;
    timer;
    waitInterval = 500;

    constructor(props) {
        super(props);
        this.renderSearchTypeButton = this.renderSearchTypeButton.bind(this);
        this.updateSeachTypeIndex = this.updateSeachTypeIndex.bind(this);
        this.renderList = this.renderList.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.searchResults = this.searchResults.bind(this);
        this.triggerChange = this.triggerChange.bind(this);

        const {selectedSearchItem, searchList} = this.props;
        this.state = {
            searchValue: this.setSearchValue(this.props),
            selectedId: selectedSearchItem && selectedSearchItem.selectedId,
            cursor: searchList.cursor,
            searchListValues: this.setSearchList(searchList)
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {selectedSearchItem, searchList} = nextProps;
        this.setState({
            searchValue: this.setSearchValue(nextProps),
            selectedId: selectedSearchItem && selectedSearchItem.selectedId,
            cursor: searchList.cursor,
            searchListValues: this.setSearchList(searchList)
        });
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside, true);
        window.addEventListener('keydown', this.handleKeyDown, true);

        this.timer = null;
        this.input.select();
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside, true);
        window.removeEventListener('keydown', this.handleKeyDown, true);
    }

    handleKeyDown(e: KeyboardEvent) {
        e.stopPropagation();
        if (e.keyCode === keyCodes.ESC) {
            this.props.handleClose();
        }
    }
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(e) {
        e.stopPropagation();
        if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
            this.props.handleClose();
        }
    }

    setSearchValue(props) {
        const searchLine = props.searchList && props.searchList.searchLine;
        if (searchLine) {
            for (let key = 0; key < searchLine.length; key++) {
                const searchLineItem = searchLine[key];
                const {selectedSearchItem} = props;
                if (selectedSearchItem && searchLineItem.retval === selectedSearchItem.selectedId) {
                    return searchLineItem.string1;
                }
            }
            return props.searchItemValue || '';
        }
        return props.searchItemValue || '';
    }

    updateSeachTypeIndex() {
        this.setState({
            searchValue: null,
            selectedId: null
        });

        this.props.handleTypeChange();
    }

    renderSearchTypeButton() {
        const {cursor} = this.state;

        return (
            <div className="search-button">
                <div className="button" onClick={this.updateSeachTypeIndex}>
                    {cursor}
                </div>
            </div>
        );
    }

    renderHeader() {
        return (
            <header>
                <div className="close-mark" onClick={this.props.handleClose}>
                    X
                </div>
            </header>
        );
    }

    searchResults(e) {
        clearTimeout(this.timer);
        this.setState({
            selectedId: null,
            searchValue: e.target.value
        });
        this.timer = setTimeout(this.triggerChange, this.waitInterval);
    }

    triggerChange() {
        const {searchValue} = this.state;
        this.props.handleSearch(searchValue, this.props.condValue);
    }

    renderSearchInput() {
        const {selectedSearchItem, searchList} = this.props;
        const {selectedId, searchValue} = this.state;
        const inputValue =
            selectedId && selectedSearchItem && selectedSearchItem.searchValue
                ? selectedSearchItem.searchValue
                : searchValue;

        const directionStyle: any = {
            direction: searchList.alignright ? 'rtl' : 'ltr'
        };

        return (
            <div className="condition-search-input">
                <input
                    type="text"
                    style={directionStyle}
                    ref={i => (this.input = i)}
                    value={inputValue}
                    onChange={this.searchResults}
                />
            </div>
        );
    }

    selectItem(id, value) {
        const selectedItem = {
            searchValue: value,
            selectedId: id
        };
        this.setState({...selectedItem});

        this.props.handleSelect(selectedItem, this.props.condValue);
        this.props.handleClose();
    }

    setSearchList(searchList) {
        const searchLine = searchList && searchList.searchLine;
        const fields: any = [];

        if (searchLine) {
            for (let key = 0; key < searchLine.length; key++) {
                const searchLineItem = searchLine[key];
                const item = {
                    string1: searchLineItem.string1,
                    string2: searchLineItem.string2,
                    retval: searchLineItem.retval
                };

                fields.push(item);
            }
        }

        return fields;
    }

    handleScroll(e) {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottom) {
            this.props.handleScroll(this.state.searchValue);
        }
    }

    renderList() {
        const {searchList} = this.props;
        const {searchListValues, selectedId} = this.state;

        return (
            <div className="list-area" onScroll={this.handleScroll}>
                {searchListValues.map((field, idx) => {
                    const retval = field.retval;
                    const val1 = searchList.alignright ? field.string1 : field.string2;
                    const val2 = searchList.alignright ? field.string2 : field.string1;

                    let leftValue = retval;
                    let rightValue = val1;
                    let selectedItemValue = val1;

                    if (searchList.cursorIndex === 7) {
                        leftValue = val2;
                        rightValue = retval;
                        selectedItemValue = val2;
                    }

                    let itemClass = 'list-item';
                    if (field.retval === selectedId) {
                        itemClass = `${itemClass} selected`;
                    }

                    return (
                        <div
                            className={itemClass}
                            key={idx}
                            onClick={() => {
                                this.selectItem(field.retval, selectedItemValue);
                            }}
                        >
                            <span className="left-value">{leftValue}</span>
                            <span className="right-value">{rightValue}</span>
                        </div>
                    );
                })}
            </div>
        );
    }

    renderOptionBoxed() {
        const {searchList} = this.props;

        return (
            <div className="options-container">
                <div>
                    <label>
                        <input
                            type="checkbox"
                            name="checkbox"
                            onChange={() => {
                                this.props.handleSearchFromStart(this.state.searchValue);
                            }}
                            checked={!!searchList.startIndex}
                        />
                        {searchList.starttitle}
                    </label>
                </div>
                <div>
                    <label>
                        <input
                            type="checkbox"
                            name="checkbox"
                            onChange={() => {
                                this.props.handleIngonreCase(this.state.searchValue);
                            }}
                            checked={!!searchList.ignorecase}
                        />
                        {/* לא להבחין בין אותיות גדולות לקטנות */}
                        {getLocalizedText(texts.ignoreCaseText)}
                    </label>
                </div>
            </div>
        );
    }

    render() {
        return (
            <section ref={this.setWrapperRef} className="search-panel">
                <div className="fade-wrapper" />
                {this.renderHeader()}
                {this.renderSearchInput()}
                {this.renderSearchTypeButton()}
                {this.renderList()}
                {this.renderOptionBoxed()}
            </section>
        );
    }
}

export default SearchPanel;
